import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  CrossPlatformLocationIcon,
  ReactIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Native Android App Development",
    description: (
      <>
        We specialize in crafting cutting-edge Android applications that
        transform your innovative ideas into powerful, user-friendly mobile
        solutions. Our team of skilled android app developers in Dallas and
        designers is dedicated to delivering top-notch{" "}
        <Link
          to="/android-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Android app development services
        </Link>{" "}
        With a commitment to quality, usability, and on-time delivery, we ensure
        your Android app stands out in a highly competitive market.
      </>
    ),
  },
  {
    icon: IphoneIcon,
    title: "Native IOS App Development",
    description: (
      <>
        Our iPhone app development services are well-suited to harness the full
        potential of the iOS ecosystem. Whether you need a consumer-facing app
        to expand your brand's reach or an enterprise solution to streamline
        your business operations, we have the expertise to build a reliable
        solution. With a commitment to quality and performance, we believe that
        your{" "}
        <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
          iPhone app development services
        </Link>{" "}
        in Dallas exceed your expectations.
      </>
    ),
  },
  {
    icon: GameIcon,
    title: "Game App Development",
    description: (
      <>
        We are experts in crafting immersive and entertaining gaming
        experiences. Our{" "}
        <Link to="/game-development" rel="noopener" aria-label="TekRevol">
          game app development services
        </Link>{" "}
        encompass the entire game development lifecycle, from conceptualization
        to design, development, and post-launch support. Whether it's casual
        mobile games or complex, high-end gaming experiences, we have the
        technical expertise and creative flair to bring your gaming vision to
        life.
      </>
    ),
  },
  {
    icon: FlutterIcon,
    title: "Flutter App Development",
    description: (
      <>
        Flutter is the future of cross-platform app development, and we are at
        the forefront of utilizing its power. Our{" "}
        <Link
          to="/flutter-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Flutter app development services
        </Link>{" "}
        cater to businesses seeking efficient and cost-effective solutions for
        iOS and Android platforms. Our experienced Flutter developers leverage
        this open-source framework to create highly responsive apps. That’s how
        we ensure a faster time to market and reduced development costs.
      </>
    ),
  },
  {
    icon: CrossPlatformLocationIcon,
    title: "Cross-Platform App Development",
    description:
      "Our cross-platform app development service helps your app reach a wider audience by maintaining its presence on both iOS and Android platforms. We deliver a high-performance and user-centric experience based on advanced frameworks like React Native and Flutter. You can leverage our expert resources to create maximum impact with our efficient cross-platform solutions as per your business needs.",
  },
  {
    icon: ReactIcon,
    title: "React Native App Development",
    description:
      "With React Native, our experienced developers can create apps that look and feel native while saving you time and resources. Our React Native app development services bring you the best of the efficiency of cross-platform development and the performance of native apps. Whether you're a startup looking to quickly launch your app or an established brand seeking to extend your mobile presence, we deliver efficient and user-friendly applications.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Our End-to-End Mobile App Development Services in Dallas</h2>
            <p className="impro_para">
              With our versatile custom app solutions, you can rely on TekRevol
              as your innovation partner to transform your business operations.
              With our dynamic landscape of technology and proven methodologies,
              we serve our clients as a full-fledged app development company in
              Dallas. There are multiple services available that you can avail
              of based on your business requirements and the market demand.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={10} className="m-auto">
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
